import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { gql } from "@apollo/client";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type MetaTags {\n    robots: String\n    title: String\n    keywords: String\n    description: String\n    canonicalUrl: String\n  }\n\n  type WebPage @cacheControl(maxAge: 300) {\n    id: Int\n    content: String\n    style: String\n    script: String\n    metatags: MetaTags\n  }\n\n  type Query {\n    webPage(path: String): WebPage\n  }\n"])));
export var resolvers = {
  Query: {
    webPage: function () {
      var _webPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, args, _ref) {
        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataSources = _ref.dataSources;
                _context.next = 3;
                return dataSources.webPage.getPage(args.path);

              case 3:
                res = _context.sent;
                return _context.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
                  metatags: _objectSpread({
                    robots: res.robots,
                    canonicalUrl: res.canonical_url
                  }, res.values)
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function webPage(_x, _x2, _x3) {
        return _webPage.apply(this, arguments);
      }

      return webPage;
    }()
  }
};